import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
const GetSeriesBySubscriptionSku = graphql(`
  query GetSeriesBySubscriptionSku(
    $skus: [String!]
    $language: String!
    $tenantId: ID!
  ) {
    product {
      getVariants(tenantId: $tenantId, language: $language, skus: $skus) {
        product {
          components {
            componentId
            name
            type
            content {
              ...SeriesDefinitionRelationContent
              ...SeriesDefinitionStatusContent
            }
          }
        }
      }
    }
  }

  fragment SeriesDefinitionRelationContent on ItemRelationsContent {
    items {
      id
      name
      components {
        componentId
        name
        type
        content {
          ...SeriesDefinitionBooksContent
        }
      }
    }
  }

  fragment SeriesDefinitionBooksContent on ItemRelationsContent {
    productVariants {
      id
      name
      sku
    }
  }
  fragment SeriesDefinitionStatusContent on SelectionContent {
    options {
      key
      value
    }
  }
`);
export default GetSeriesBySubscriptionSku;
